import useSWR from "swr";
import { getPersistData } from "../persist";

const swrData: any = getPersistData("LOCAL@MITORDER") || {};

export function useMitOrder() {
	const mitData:any = [];
	const { data, mutate } = useSWR<any>('LOCAL@MITORDER', async () => {
		return swrData || {}
	})

	const keys = Object.keys(data || []);

	for (const key of keys) {
		if (key == "NO") continue;

		const item = data[key];

		item?.map((mit: any) => {
			const temp = {
				status: 10,
				exchange_pairs_id: parseInt(key?.replace("MIT", "")),
				// leverage: tradeSetting?.leverage || 1,
				limit_market: mit.limit_market == "CL" ? "L" : "M",
				order_price: mit.price,
				trigger_price: mit.trigger_price,
				trigger_type: mit.trigger_type,
				long_short: mit.longshort,
				amount: mit?.amount,
				created_at: mit?.created_at,
			};
			mitData.push(temp);
		});
	}

	return {
		data,
		mitDataLength: mitData.length,
		mutate: (value?: any, epid?: number) => {
			try {
				if (value !== undefined) {
					if (epid) {
						swrData['MIT' + epid] = value

						if (value && value.length == 0) {
							delete swrData['MIT' + epid]

							swrData['NO'] = [{ id: Math.random() }]
						}
						return mutate({ ...swrData })
					}
				}
				return mutate()
			} catch (e) {
				return mutate()
			}
		},
	}
}
